import { range } from 'ramda'
import React, { useMemo } from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableColText, TableHeadText } from '../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import { getValidity, formatValidityMonth } from '../../_helpers/pdfHelpers'

const SchedulingSection = ({ serviceOrder }) => {
  const validityMonth = useMemo(() => {
    const date = getValidity(serviceOrder)
    return formatValidityMonth(date)
  }, [serviceOrder])

  return (
    <View id="5">
      <Separator weight={8} />
      <Text bold size="small">
        5 CRONOGRAMA DO INVENTÁRIO DE RISCOS E PLANO DE AÇÃO
      </Text>

      <Separator weight={8} />

      <Table width="100%">
        <TableRow>
          <TableHeadText rowSpan={3} align="center">
            #
          </TableHeadText>

          <TableHeadText rowSpan={3} align="center">
            Ações
          </TableHeadText>

          <TableHeadText rowSpan={3} align="center">
            Status
          </TableHeadText>

          <TableHeadText align="center" colSpan={12}>
            Planejamento Ano/Ano
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableHeadText align="center" colSpan={12}>
            Data da elaboração: MÊS/ANO
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableHeadText align="center">JAN</TableHeadText>
          <TableHeadText align="center">FEV</TableHeadText>
          <TableHeadText align="center">MAR</TableHeadText>
          <TableHeadText align="center">ABR</TableHeadText>
          <TableHeadText align="center">MAI</TableHeadText>
          <TableHeadText align="center">JUN</TableHeadText>
          <TableHeadText align="center">JUL</TableHeadText>
          <TableHeadText align="center">AGO</TableHeadText>
          <TableHeadText align="center">SET</TableHeadText>
          <TableHeadText align="center">OUT</TableHeadText>
          <TableHeadText align="center">NOV</TableHeadText>
          <TableHeadText align="center">DEZ</TableHeadText>
        </TableRow>

        <TableRow>
          <TableColText align="center">1</TableColText>
          <TableColText align="center">
            Planejamento para estabelecimento de prioridade e metas de avaliação e controle da monitoração da exposição.
          </TableColText>
          <TableColText align="center">Em andamento</TableColText>
          {range(1, 13).map(i => (
            <TableColText align="center" key={i}>
              X
            </TableColText>
          ))}
        </TableRow>

        <TableRow>
          <TableColText align="center">2</TableColText>
          <TableColText align="center">Estabelecer, implementar e assegurar o cumprimento do PGR</TableColText>
          <TableColText align="center">Em andamento</TableColText>
          {range(1, 13).map(i => (
            <TableColText align="center" key={i}>
              X
            </TableColText>
          ))}
        </TableRow>

        <TableRow>
          <TableColText align="center">3</TableColText>
          <TableColText align="center">
            Orientar e treinar os colaboradores quanto a correta postura e ajustes do posto de trabalho, em atendimento
            à NR17
          </TableColText>
          <TableColText align="center">Em andamento</TableColText>
          {range(1, 13).map(i => (
            <TableColText align="center" key={i}>
              X
            </TableColText>
          ))}
        </TableRow>

        <TableRow>
          <TableColText align="center">4</TableColText>
          <TableColText align="center">
            Análise do PGR Efetuar análise do PGR para avaliação do seu desenvolvimento e realização dos ajustes
            necessários
          </TableColText>
          <TableColText align="center">Em andamento</TableColText>
          {range(1, 13).map(i => (
            <TableColText align="center" key={i}>
              {i >= validityMonth ? 'X' : ''}
            </TableColText>
          ))}
        </TableRow>

        <TableRow>
          <TableColText align="center">5</TableColText>
          <TableColText align="center">
            Aprofundar os possíveis riscos ergonômicos antecipados no PGR, na AET
          </TableColText>
          <TableColText align="center">Realizado</TableColText>
          {range(1, 13).map(i => (
            <TableColText align="center" key={i}>
              {i === validityMonth ? 'X' : ''}
            </TableColText>
          ))}
        </TableRow>
      </Table>

      <Separator weight={8} />
    </View>
  )
}

export default SchedulingSection
